import { cn } from '@/utils/utils';
import React from 'react';

export default function GridCampaignCard({ className, ...rest }: { className?: string } & React.ComponentProps<'div'>) {
  return (
    <div
      {...rest}
      className={cn(
        'grid min-h-32 w-full grid-cols-[repeat(auto-fill,minmax(95px,1fr))] gap-2 py-2 md:grid-cols-[repeat(auto-fill,minmax(95px,1fr))] lg:grid-cols-[repeat(auto-fill,minmax(95px,1fr))]',
        className
      )}
    >
      {rest.children}
    </div>
  );
}
